export const lightTheme = {
    unresolvedBannerBg: '#fcebeb',
    unresolvedBannerText: '#a32d2d',
    unresolvedBadgeBg: '#f7c1c1',
    unresolvedBadgeText: '#791f1f',
    resolvedBannerBg: '#eaf3de',
    resolvedBannerText: '#3b6d11',
    statusBannerNeutralBg: '#f0f2f5',
    statusBannerNeutralText: '#5a6673',
    background: '#f8fafd',
    backgroundAlt: '#FFFFFF',
    border: 'rgb(226, 233, 244)',
    borderAlt: '#E8EDF6',
    text: '#000000',
    textSecondary: 'rgba(158, 171, 204, 1)',
    textBold: '#000000',
    inputBg: '#FFFFFF',
    inputBgSolid: '#FFFFFF',
    inputBorder: '#E2E9F4',
    messageBgInbound: '#DCDCDB',
    messageTextInbound: '#333333',
    messageBgOutbound: '#0065DB',
    messageTextOutbound: '#F8FAFD',
    messageInfoTextOutbound: '#0065DB',
    subjectSeparatorInbound: '#333333',
    subjectSeparatorOutbound: '#F8FAFD',
    noteBg: '#FFFF99',
    noteBorder: 'rgb(226, 233, 244)',
    noteText: '#000',
    actionBorder: '#3CA6F5',
    actionTooltipBg: '#FFFFFF',
    actionTooltipBorder: '#E2E9F4',
    loadMoreBg: '#F8FAFD',
    loadMoreBorder: '#E2E9F4',
    searchBg: '#FFFFFF',
    selectedFeedBg: 'rgba(60, 166, 245, 0.1)',
    placeholderColor: undefined,
    contactPhoneColor: undefined,
    feedbackFieldBg: 'transparent',
};

export const darkTheme = {
    unresolvedBannerBg: '#352125',
    unresolvedBannerText: '#F4A6A6',
    unresolvedBadgeBg: '#583036',
    unresolvedBadgeText: '#FFD6D6',
    resolvedBannerBg: '#203024',
    resolvedBannerText: '#B1D78B',
    statusBannerNeutralBg: '#262D31',
    statusBannerNeutralText: '#9EABCC',
    background: '#0E161A',
    backgroundAlt: '#0E161A',
    border: '#343A43',
    borderAlt: '#343A43',
    text: '#FFFFFF',
    textSecondary: '#9EABCC',
    textBold: '#FFFFFF',
    inputBg: 'rgba(248, 250, 253, 0.1)',
    inputBgSolid: '#262D31',
    inputBorder: '#343A43',
    messageBgInbound: 'rgba(255, 255, 255, 0.1)',
    messageTextInbound: '#FFFFFF',
    messageBgOutbound: 'rgba(60, 166, 245, 0.2)',
    messageTextOutbound: '#F8FAFD',
    messageInfoTextOutbound: '#3CA6F5',
    subjectSeparatorInbound: '#FFFFFF',
    subjectSeparatorOutbound: '#F8FAFD',
    noteBg: '#FFFF99',
    noteBorder: '#343A43',
    noteText: '#000',
    actionBorder: '#FFFFFF',
    actionTooltipBg: '#0E161A',
    actionTooltipBorder: '#343A43',
    loadMoreBg: 'rgba(248, 250, 253, 0.1)',
    loadMoreBorder: '#343A43',
    searchBg: 'rgba(248, 250, 253, 0.1)',
    selectedFeedBg: 'rgba(60, 166, 245, 0.1)',
    placeholderColor: '#757575',
    contactPhoneColor: '#9EABCC',
    feedbackFieldBg: 'rgba(255, 255, 255, 0.05)',
};

export const THEME_TRANSITION_MS = 800;
export const THEME_TRANSITION_EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

export const getThemeTransitionStyle = (properties = 'background-color,border-color,color') => ({
    transitionDuration: `${THEME_TRANSITION_MS}ms`,
    transitionProperty: properties,
    transitionTimingFunction: THEME_TRANSITION_EASING,
});
